export var VERSION = '2.6.2';
//# sourceMappingURL=version.js.map